import { Box, Button, IconButton, Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import { useState } from "react";

import CustomCard from "../../../../../components/CustomCard";
import CustomModal from "../../../../../components/CustomModal";
import ImageUploaderContainer from "./ImageUploaderContainer";

const ImageUploader = () => {
  const [uploadLoading, setUploadLoading] = useState(false);

  const ModalOpen = (
    <Button variant="contained" color="primary" startIcon={<AddIcon />}>
      Upload
    </Button>
  );

  return (
    <CustomModal disableBackdropClick ModalOpenButton={ModalOpen}>
      {(props: any) => (
        <CustomCard height="75vh" width="75%">
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h6" color="textSecondary">
              Image Uploader
            </Typography>
            <IconButton onClick={props.handleCloseModal} disabled={uploadLoading}>
              <CloseIcon />
            </IconButton>
          </Box>

          <ImageUploaderContainer triggerLoadingOnSubmit={setUploadLoading} />
        </CustomCard>
      )}
    </CustomModal>
  );
};

export default ImageUploader;
